import { createAsyncThunk, createSlice } from "@reduxjs/toolkit"
import { endpoints } from "../../../config/endpoints"
import axiosConfig from "../../../utils/axiosConfig"

const initialState = {
    deviceCategories: [],
    loading: false,
    error: ""
}

export const getdeviceCategories = createAsyncThunk('deviceCategories/fetch',  async (amount) => {
    return axiosConfig(endpoints.deviceCategories)
})

const deviceCategorieslice = createSlice({
    name: 'deviceCategories',
    initialState,
    extraReducers: (builder) => {
        builder.addCase(getdeviceCategories.pending, state => {
            state.loading = true
        })
        builder.addCase(getdeviceCategories.fulfilled, (state, action) => {
            state.loading = false
            state.deviceCategories = action.payload
            state.error = ""
           

        })
        builder.addCase(getdeviceCategories.rejected, (state, action) => {
            state.loading = false
            state.deviceCategories = {}
            state.error = "Error, Failed to load deviceCategories"
        })
     
    }
})

export default deviceCategorieslice.reducer

